module.exports = __webpack_public_path__ + "img/setting-set.ec37ffbd.png";